define('Components/JobWidget/js/models/JobWidgetInstanceModel',['underscore',
        'WidgetInstanceModel',
        'Components/JobWidget/js/models/JobWidgetModel'
    ],
    function (_,
              WidgetInstanceModel,
              JobWidgetModel) {

    //
    // Instance de Widget
    //

    return WidgetInstanceModel.extend({
        name: 'JobWidgetModel',
        init: function () {
            var model = this;


        },
        getId:function(){
            return this.get('id_widget_instance');
        },

        getFields:function() {
            return _({
                'lastname': {
                    type: 'text',
                    label: app.t('Nom', 'JobWidget'),
                    required: true,
                    small: true,
                },
                'firstname': {
                    type: 'text',
                    label: app.t('Prénom', 'JobWidget'),
                    small: true,
                },
                'address': {
                    type: 'text',
                    label: app.t('Adresse', 'JobWidget'),
                },
                'city': {
                    type: 'text',
                    label: app.t('Ville', 'JobWidget'),
                    required: true,
                },
                'phone': {
                    type: 'tel',
                    label: app.t('Portable', 'JobWidget'),
                    required: true,
                    small: true,
                },
                'email': {
                    type: 'email',
                    label: app.t('Email', 'JobWidget'),
                    required: true,
                    small: true,
                },
                'brand': {
                    type: 'text',
                    label: app.t('Enseigne d’hypermarché', 'JobWidget'),
                },
                'message': {
                    type: 'textarea',
                    label: app.t('Votre projet', 'JobWidget'),
                },
            })
        }

    })
});
